<template>
    <div>
        <b-card class="mb-3 shadow" :title="$t(`settings.card_contracttypes`)">
            <b-button class="button-margin" variant="primary" @click.prevent="showNewItemForm" v-if="hasRole('Administrator')||hasRole('Berater')"><b-icon icon="folder-plus" />{{ $t("settings.new") }}</b-button>
            <br />
            <div class="table-scrollable">
                <b-table striped hover :items="contractTypes" :fields="contracttypefields">
                    <template #cell(actions)="data">
                        <b-link class="m-1" href="#" v-show="data.index > 0" @click="moveItemUp(data.item.id)"><b-icon icon="chevron-up" scale="1.2"></b-icon></b-link>
                        <b-link class="m-1" href="#" v-show="data.index < contractTypes.length-1" @click="moveItemDown(data.item.id)"><b-icon icon="chevron-down" scale="1.2"></b-icon></b-link>
                        <b-link class="m-1" href="#" @click="editItem(data.item)" v-if="hasRole('Administrator')||hasRole('Berater')"><b-icon icon="pencil-square" scale="1.2"></b-icon></b-link>
                        <b-link class="m-1" href="#" @click="requestConfirmation(data.item)" v-if="hasRole('Administrator')||hasRole('Berater')"><b-icon icon="trash" scale="1.2"></b-icon></b-link>
                    </template>
                </b-table>
            </div>
            <br />
            <b-modal ref="confirmationModal" hide-footer :title="$t(`settings.modal_title_delete`)">
                <div class="d-block text-center">
                    <p v-if="itemContext">{{ $t(`settings.delete_message`) }}</p>
                </div>
                <b-button class="button-margin mt-3" variant="outline-danger" block @click="executeDelete"><b-icon icon="trash" />{{ $t("settings.btn_delete") }}</b-button>
            </b-modal>
        </b-card>
        <EditContractType ref="EditContractType" :savedCallback="reload" />
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import EditContractType from './EditContractType';
    import ContractService from '../../../../../services/ContractService';

    export default {
        name: 'contracttypes',
        components: {EditContractType},
        props: [],
        data() {
            return {
                itemContext: null,
                currentItem: {}
            }
        },
        created() {
            this.fetchContractTypes();
        },
        methods: {
            ...mapActions({
                fetchContractTypes: 'contracts/fetchContractTypes',
                deleteContractTypes: 'contracts/deleteContractTypes'
            }),
            showNewItemForm() {
                this.currentItemEditMode = false;
                this.$refs.EditContractType.setItem({});
                this.$refs.EditContractType.showModal();
            },
            editItem(item) {
                this.$refs.EditContractType.setItem(item);
                this.$refs.EditContractType.showModal();
                this.$refs.EditContractType.enterEditMode();
            },
            requestConfirmation(item) {
                this.itemContext = item;
                this.$refs.confirmationModal.show();
            },
            executeDelete() {
                this.$refs.confirmationModal.hide();
                this.$store.commit('loading/setLoading', true);
                ContractService.deleteContractType(this.itemContext.id)
                    .then(response => {
                        this.$store.commit('loading/setLoading', false);
                        if(!response.data.success) {
                            this.$notify({
                                group: 'global',
                                title: 'Fehler beim Entfernen des Vertragssubjekts.',
                                type: 'error',
                                text: response.data.message
                            });
                        }

                        this.itemContext = null;
                        this.reload();
                    });
            },
            reload() {
                this.fetchContractTypes();
            },
            moveItemUp(contracttypeId) {
                this.$store.commit('loading/setLoading', true);
                ContractService.moveContractTypeUp(contracttypeId)
                    .then(response => {
                        this.$store.commit('loading/setLoading', false);
                        this.fetchContractTypes();
                    });
            },
            moveItemDown(contracttypeId) {
                this.$store.commit('loading/setLoading', true);
                ContractService.moveContractTypeDown(contracttypeId)
                    .then(response => {
                        this.$store.commit('loading/setLoading', false);
                        this.fetchContractTypes();
                    });
            }
        },
        computed: {
            ...mapGetters({
                hasRole: 'auth/hasRole',
                contractTypes: 'contracts/contractTypes'
            }),
            contracttypefields() {
                return [
                    { key: 'id',                                label: 'ID'                      },
                    { key: 'order',                             label: 'Reihenfolge'             },
                    { key: 'contract_type',                     label: 'Vertragstyp'             },
                    { key: 'actions',                           label: 'Aktionen'                },
                ];
            },
        }
    }
</script>